angular.module("khUtils").factory("PrimaryTeamOfUserFactory", ["$resource", function ($resource) {
    return $resource('api/v1.0/khutils/primary-team/', {}, {
	    query:{
		    isArray:false
	    }
    });
}]);